import * as types from './types';
export default {
  [types.SET_WISHLIST](state, payload) {
    const currentState = state;
    currentState.product = payload.product;
  },

  [types.SET_LOADING_WISHLIST](state, payload) {
    const currentState = state;
    currentState.loading = payload;
  },

  [types.ADD_WISHLIST_ITEM](state, payload) {
    const currentState = state;
    currentState.product.push(payload.reference);
  },

  [types.DELETE_WISHLIST_ITEM](state, payload) {
    const currentState = state;
    currentState.product.splice(currentState.product.indexOf(payload.reference), 1);
  }

};